/* RMS 2026-09-24 · takili kalan "reveal" niteligini kurtarir.
   Bkz. src/rms/reveal-kurtar.mjs — gerekce ve olcumler orada.
   Kapsam: yalnizca YUKLENMIS <img> ogeleri. img olmayan [reveal]
   ogelerine dokunulmaz, temanin kaydirma animasyonlari bozulmaz. */
(function () {
  'use strict';

  function kurtar() {
    var n = document.querySelectorAll('img[reveal]');
    for (var i = 0; i < n.length; i++) {
      // complete + naturalWidth: gorsel gercekten geldi demektir.
      // Hata veren gorsellerde complete=true ama naturalWidth=0 olur;
      // onlari acmanin anlami yok, temanin hata yolunu bozmayalim.
      if (n[i].complete && n[i].naturalWidth > 0) n[i].removeAttribute('reveal');
    }
  }

  kurtar();
  document.addEventListener('DOMContentLoaded', kurtar);
  window.addEventListener('load', kurtar);

  // Tema gorselleri varyant degisiminde yeniden ciziyor; kisa sure izle.
  var sayac = 0;
  var t = setInterval(function () {
    kurtar();
    if (++sayac > 20) clearInterval(t);   // 20 x 400ms = 8 sn
  }, 400);
})();
